import Api from "../Utils/api";

const FeedbackHandler = {
  exportFeedback: function () {
    return new Promise((resolve, reject) => {
      Api.get_doc(`Export/FeedbackExport`)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  },
};

export default FeedbackHandler;
